// Created by hejikun on 2017/11/2 0002.
let adviser = [
  {
    path: '/adviser_chat_pay',
    name: '就诊顾问',
    component: () => import('@/pages/adviser/adviser_chat_pay')
  },
  {
    path: '/adviserOrderPayDetail',
    name: '订单详情',
    component: () => import('@/pages/adviser/adviserOrderPayDetail')
  },
  {
    path: '/adviser_order_list',
    name: '消息列表',
    component: () => import('@/pages/adviser/adviser_order_list')
  },
  {
    path: '/adviser_chat_detail',
    name: '会话详情',
    component: () => import('@/pages/adviser/adviser_chat_detail')
  },
  {
    path: '/adviser_pay',
    name: '支付',
    component: () => import('@/pages/adviser/adviser_pay')
  },
  {
    path: '/adviser_yunda',
    name: '就诊顾问',
    component: () => import('@/pages/adviser/adviser_yunda')
  }
]

export default adviser
